type RoundEdgeNode = {
  readonly bookingIndex?: number | null;
  readonly id: string;
};

type RoundEdge = {
  readonly node?: RoundEdgeNode | null;
};

export type RequestRoundEntry<T extends RoundEdge = RoundEdge> = {
  edge: T;
  originalIndex: number;
};

export type RequestRoundGroup<T extends RoundEdge = RoundEdge> = {
  groupIndex: number;
  rounds: RequestRoundEntry<T>[];
};

export const getRequestRoundGroups = <T extends RoundEdge>(
  edges: readonly (T | null | undefined)[] | null | undefined,
  requestGroupCount: number
): RequestRoundGroup<T>[] => {
  const entries = (edges ?? []).flatMap((edge, originalIndex) =>
    edge?.node ? [{ edge, originalIndex }] : []
  );

  return Array.from({ length: requestGroupCount }, (_, groupIndex) => ({
    groupIndex,
    rounds: entries
      .filter(({ edge }) => (edge.node?.bookingIndex ?? 0) === groupIndex)
      .sort((a, b) => a.originalIndex - b.originalIndex),
  }));
};
